const baseStyle = {
    fontWeight: "medium",
    lineHeight: "base",
    textDecoration: "none",
    _visited: {
        color: "greyscale.600",
        svgr: {
            color: "greyscale.600",
        },
    },
    _hover: {
        textDecoration: "none",
    },
};
const variantBasic = {
    color: "primary.500",
    _hover: {
        color: { md: "primary.600" },
    },
    _active: {
        color: "primary.700",
    },
};
const variantFooterLight = {
    color: "greyscale.600",
    _hover: {
        color: { md: "primary.500" },
    },
    _active: {
        color: "primary.700",
    },
};
const variantFooterDark = {
    color: "primary.900",
    _hover: {
        color: { md: "primary.500" },
    },
    _active: {
        color: "primary.700",
    },
    _visited: {
        color: "primary.900",
        svgr: {
            color: "primary.900",
        },
    },
};
const variants = {
    basic: variantBasic,
    footerLight: variantFooterLight,
    footerDark: variantFooterDark,
};
const sizes = {
    s: {
        fontSize: "sm",
        svg: {
            boxSize: 4,
        },
    },
    m: {
        fontSize: "md",
        svg: {
            boxSize: 5,
        },
    },
    l: {
        fontSize: "lg",
        svg: {
            boxSize: 6,
        },
    },
};
const defaultProps = {
    variant: "basic",
    size: "m",
};
const Link = {
    baseStyle,
    sizes,
    variants,
    defaultProps,
};
export default Link;
